var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AjaxVueSelectFilter',{attrs:{"url":_vm.url,"initial-value":_vm.initialValue},on:{"search":function (legislations) { return _vm.$emit('selected', legislations); }}})}
var staticRenderFns = []

export { render, staticRenderFns }